/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./offitask.vue?vue&type=template&id=1d7fd79c&scoped=true"
import script from "./offitask.vue?vue&type=script&lang=js"
export * from "./offitask.vue?vue&type=script&lang=js"
import style0 from "./offitask.vue?vue&type=style&index=0&id=1d7fd79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7fd79c",
  null
  
)

export default component.exports